/**
 * New Event Modal for Dashboard
 * Main initialization file that imports and uses the modular components
 */

import { ModalManager } from '../utils/modalManager.js'
import { ClientModalHandler } from './clientModalHandler.js'
import { EventFormHandler } from './eventFormHandler.js'

// Store handler instance to prevent duplicates
let eventFormHandlerInstance = null

function initializeDashboardEventModal() {
  const modal = document.getElementById('newEventModal')
  const form = document.getElementById('newEventForm')
  const clientModal = document.getElementById('newClientModal')

  if (!modal || !form) return

  // Setup event modal close handlers
  ModalManager.setupCloseHandlers(modal, {
    closeButtonSelector: '#closeNewEventModal',
    cancelButtonSelector: '#cancelNewEvent',
    overlaySelector: '.modal-overlay',
  })

  // Initialize client modal handler
  if (clientModal) {
    const clientModalHandler = new ClientModalHandler(clientModal, modal)
    clientModalHandler.init()
  }

  // Initialize or re-initialize event form handler
  // Re-initialize to ensure handler is always ready, especially if modal was opened dynamically
  eventFormHandlerInstance = new EventFormHandler(form, modal)
  eventFormHandlerInstance.init()
}

// Make initialization function globally available so it can be called when modal opens
window.initializeDashboardEventModal = initializeDashboardEventModal

// Initialize on page load and Turbo events
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeDashboardEventModal)
} else {
  initializeDashboardEventModal()
}

document.addEventListener('turbo:load', initializeDashboardEventModal)
document.addEventListener('turbo:frame-load', initializeDashboardEventModal)
